/**
 * Configuration centralisée du diagramme de validation.
 * Toutes les dimensions et espacements sont définis ici.
 */

// ─── Largeurs ────────────────────────────────────────────────────────────────

/** Largeur des nodes standards (exclusions, conditions, bonus). */
export const NODE_DEFAULT_WIDTH = 480;

/** Largeur du node source "Employé". */
export const SOURCE_WIDTH = 200;

// ─── Hauteurs des nodes ───────────────────────────────────────────────────────

/** Hauteur du node source "Employé". */
export const SOURCE_HEIGHT = 64;

/**
 * Chrome d'un NodeShell : liseré d'accent (4px) + header (32px) + paddings
 * internes top/bottom (20px). Base partagée par toutes les variantes colorées.
 */
export const SHELL_CHROME_HEIGHT = 56 + 33;

/** Hauteur d'un node placeholder ("Rien" / "Aucune prime"). */
export const PLACEHOLDER_HEIGHT = SHELL_CHROME_HEIGHT + 60;

/** Hauteur de base d'un node bonus (sans conditions ni taux). */
export const BONUS_BASE_HEIGHT = SHELL_CHROME_HEIGHT + 200;

/** Hauteur d'une ligne de condition dans un node bonus. */
export const BONUS_CONDITION_ROW_HEIGHT = 24;

/** Hauteur supplémentaire du bloc taux (méthodes Base×Taux et Base×Montant). */
export const BONUS_TAUX_BLOCK_HEIGHT = 50;

/** Hauteur de base d'un node exclusions/conditions (sans lignes de règles). */
export const CONDITIONS_BASE_HEIGHT = SHELL_CHROME_HEIGHT + 70;

/** Hauteur d'une ligne de règle dans un node exclusions/conditions. */
export const CONDITIONS_ROW_HEIGHT = 36;

/** Nombre maximum de lignes affichées dans un node conditions/exclusions. */
export const MAX_VISIBLE_ROWS = 3;

/** Nombre maximum d'exclusions pouvant être configurées. */
export const MAX_EXCLUSION_CONDITIONS = 5;

// ─── Espacements ELK ─────────────────────────────────────────────────────────

/** Espacement vertical entre couches successives (Employé → Exclusions → …). */
export const LAYER_SPACING = 80;

/** Espacement horizontal entre nodes d'une même couche (branches IF / ELSE). */
export const NODE_NODE_SPACING = 60;

/**
 * Espacement vertical entre couches dans un groupe de primes (sub-flow),
 * ex. entre « Conditions de la prime » et la carte prime.
 */
export const BRANCH_GROUP_LAYER_SPACING = 100;
